// extracted by mini-css-extract-plugin
export var option = "_4o-1";
export var optionActive = "_4o-2";
export var pill = "_4o-0";